import { lazy } from 'react'
export const lazyIcons = {
  BrandIconAcai: lazy(() => import('./BrandIconAcai.mjs')),
  BrandIconAccessiblePharmacy: lazy(
    () => import('./BrandIconAccessiblePharmacy.mjs'),
  ),
  BrandIconActionInApp: lazy(() => import('./BrandIconActionInApp.mjs')),
  BrandIconAddress: lazy(() => import('./BrandIconAddress.mjs')),
  BrandIconAirplane: lazy(() => import('./BrandIconAirplane.mjs')),
  BrandIconAllergy: lazy(() => import('./BrandIconAllergy.mjs')),
  BrandIconAloeVera: lazy(() => import('./BrandIconAloeVera.mjs')),
  BrandIconAmpoule: lazy(() => import('./BrandIconAmpoule.mjs')),
  BrandIconAmpouleWithLid: lazy(() => import('./BrandIconAmpouleWithLid.mjs')),
  BrandIconApp: lazy(() => import('./BrandIconApp.mjs')),
  BrandIconArteriesAndBloodCapillaries: lazy(
    () => import('./BrandIconArteriesAndBloodCapillaries.mjs'),
  ),
  BrandIconBaby: lazy(() => import('./BrandIconBaby.mjs')),
  BrandIconBabyBear: lazy(() => import('./BrandIconBabyBear.mjs')),
  BrandIconBack: lazy(() => import('./BrandIconBack.mjs')),
  BrandIconBarcode: lazy(() => import('./BrandIconBarcode.mjs')),
  BrandIconBathSalts: lazy(() => import('./BrandIconBathSalts.mjs')),
  BrandIconBeauty: lazy(() => import('./BrandIconBeauty.mjs')),
  BrandIconBeautyFemale: lazy(() => import('./BrandIconBeautyFemale.mjs')),
  BrandIconBeautyMale: lazy(() => import('./BrandIconBeautyMale.mjs')),
  BrandIconBillboard: lazy(() => import('./BrandIconBillboard.mjs')),
  BrandIconBladder: lazy(() => import('./BrandIconBladder.mjs')),
  BrandIconBloodPressure: lazy(() => import('./BrandIconBloodPressure.mjs')),
  BrandIconBlueberries: lazy(() => import('./BrandIconBlueberries.mjs')),
  BrandIconBone: lazy(() => import('./BrandIconBone.mjs')),
  BrandIconBoneAndJoints: lazy(() => import('./BrandIconBoneAndJoints.mjs')),
  BrandIconBookmark: lazy(() => import('./BrandIconBookmark.mjs')),
  BrandIconBrain: lazy(() => import('./BrandIconBrain.mjs')),
  BrandIconBrand: lazy(() => import('./BrandIconBrand.mjs')),
  BrandIconBundle: lazy(() => import('./BrandIconBundle.mjs')),
  BrandIconBusinessIdea: lazy(() => import('./BrandIconBusinessIdea.mjs')),
  BrandIconCalendar: lazy(() => import('./BrandIconCalendar.mjs')),
  BrandIconCapsule: lazy(() => import('./BrandIconCapsule.mjs')),
  BrandIconCat: lazy(() => import('./BrandIconCat.mjs')),
  BrandIconCategories: lazy(() => import('./BrandIconCategories.mjs')),
  BrandIconCellDivision: lazy(() => import('./BrandIconCellDivision.mjs')),
  BrandIconCheckmark: lazy(() => import('./BrandIconCheckmark.mjs')),
  BrandIconCheckmarkInApp: lazy(() => import('./BrandIconCheckmarkInApp.mjs')),
  BrandIconChildrenColdsAndFlu: lazy(
    () => import('./BrandIconChildrenColdsAndFlu.mjs'),
  ),
  BrandIconCholesterol: lazy(() => import('./BrandIconCholesterol.mjs')),
  BrandIconCircularPatch: lazy(() => import('./BrandIconCircularPatch.mjs')),
  BrandIconClover: lazy(() => import('./BrandIconClover.mjs')),
  BrandIconCold: lazy(() => import('./BrandIconCold.mjs')),
  BrandIconCollectRedPoints: lazy(
    () => import('./BrandIconCollectRedPoints.mjs'),
  ),
  BrandIconCologne: lazy(() => import('./BrandIconCologne.mjs')),
  BrandIconCommunication: lazy(() => import('./BrandIconCommunication.mjs')),
  BrandIconCompass: lazy(() => import('./BrandIconCompass.mjs')),
  BrandIconContactLenses: lazy(() => import('./BrandIconContactLenses.mjs')),
  BrandIconCourierBike: lazy(() => import('./BrandIconCourierBike.mjs')),
  BrandIconCranberry: lazy(() => import('./BrandIconCranberry.mjs')),
  BrandIconCreme: lazy(() => import('./BrandIconCreme.mjs')),
  BrandIconCristal: lazy(() => import('./BrandIconCristal.mjs')),
  BrandIconCurcuma: lazy(() => import('./BrandIconCurcuma.mjs')),
  BrandIconCustomers: lazy(() => import('./BrandIconCustomers.mjs')),
  BrandIconDecision: lazy(() => import('./BrandIconDecision.mjs')),
  BrandIconDeliveryPerson: lazy(() => import('./BrandIconDeliveryPerson.mjs')),
  BrandIconDevices: lazy(() => import('./BrandIconDevices.mjs')),
  BrandIconDiagestion: lazy(() => import('./BrandIconDiagestion.mjs')),
  BrandIconDissolvingTablet: lazy(
    () => import('./BrandIconDissolvingTablet.mjs'),
  ),
  BrandIconDna: lazy(() => import('./BrandIconDna.mjs')),
  BrandIconDoctor: lazy(() => import('./BrandIconDoctor.mjs')),
  BrandIconDog: lazy(() => import('./BrandIconDog.mjs')),
  BrandIconDonation: lazy(() => import('./BrandIconDonation.mjs')),
  BrandIconDrops: lazy(() => import('./BrandIconDrops.mjs')),
  BrandIconDrugSuggestion: lazy(() => import('./BrandIconDrugSuggestion.mjs')),
  BrandIconDumbbell: lazy(() => import('./BrandIconDumbbell.mjs')),
  BrandIconEar: lazy(() => import('./BrandIconEar.mjs')),
  BrandIconElectronicPrescription: lazy(
    () => import('./BrandIconElectronicPrescription.mjs'),
  ),
  BrandIconEucalyptus: lazy(() => import('./BrandIconEucalyptus.mjs')),
  BrandIconEuro: lazy(() => import('./BrandIconEuro.mjs')),
  BrandIconExpressDelivery: lazy(
    () => import('./BrandIconExpressDelivery.mjs'),
  ),
  BrandIconExtraRedPoints: lazy(() => import('./BrandIconExtraRedPoints.mjs')),
  BrandIconEye: lazy(() => import('./BrandIconEye.mjs')),
  BrandIconFenugreek: lazy(() => import('./BrandIconFenugreek.mjs')),
  BrandIconFever: lazy(() => import('./BrandIconFever.mjs')),
  BrandIconFindDrugWithApp: lazy(
    () => import('./BrandIconFindDrugWithApp.mjs'),
  ),
  BrandIconFlyer: lazy(() => import('./BrandIconFlyer.mjs')),
  BrandIconFoot: lazy(() => import('./BrandIconFoot.mjs')),
  BrandIconForbiddance: lazy(() => import('./BrandIconForbiddance.mjs')),
  BrandIconFormFilling: lazy(() => import('./BrandIconFormFilling.mjs')),
  BrandIconFree: lazy(() => import('./BrandIconFree.mjs')),
  BrandIconGel: lazy(() => import('./BrandIconGel.mjs')),
  BrandIconGermanyPharmacy: lazy(
    () => import('./BrandIconGermanyPharmacy.mjs'),
  ),
  BrandIconGinger: lazy(() => import('./BrandIconGinger.mjs')),
  BrandIconGinkgo: lazy(() => import('./BrandIconGinkgo.mjs')),
  BrandIconGinseng: lazy(() => import('./BrandIconGinseng.mjs')),
  BrandIconGrowth: lazy(() => import('./BrandIconGrowth.mjs')),
  BrandIconHair: lazy(() => import('./BrandIconHair.mjs')),
  BrandIconHand: lazy(() => import('./BrandIconHand.mjs')),
  BrandIconHead: lazy(() => import('./BrandIconHead.mjs')),
  BrandIconHeart: lazy(() => import('./BrandIconHeart.mjs')),
  BrandIconHempCbd: lazy(() => import('./BrandIconHempCbd.mjs')),
  BrandIconHorse: lazy(() => import('./BrandIconHorse.mjs')),
  BrandIconIncreaseMetabolism: lazy(
    () => import('./BrandIconIncreaseMetabolism.mjs'),
  ),
  BrandIconInternationalDelivery: lazy(
    () => import('./BrandIconInternationalDelivery.mjs'),
  ),
  BrandIconKey: lazy(() => import('./BrandIconKey.mjs')),
  BrandIconKidneys: lazy(() => import('./BrandIconKidneys.mjs')),
  BrandIconLemon: lazy(() => import('./BrandIconLemon.mjs')),
  BrandIconLightBoxForAdvertising: lazy(
    () => import('./BrandIconLightBoxForAdvertising.mjs'),
  ),
  BrandIconLike: lazy(() => import('./BrandIconLike.mjs')),
  BrandIconLips: lazy(() => import('./BrandIconLips.mjs')),
  BrandIconLiquid: lazy(() => import('./BrandIconLiquid.mjs')),
  BrandIconLiver: lazy(() => import('./BrandIconLiver.mjs')),
  BrandIconLoading: lazy(() => import('./BrandIconLoading.mjs')),
  BrandIconLocation: lazy(() => import('./BrandIconLocation.mjs')),
  BrandIconLozengeSplitted: lazy(
    () => import('./BrandIconLozengeSplitted.mjs'),
  ),
  BrandIconLungs: lazy(() => import('./BrandIconLungs.mjs')),
  BrandIconManufacturer: lazy(() => import('./BrandIconManufacturer.mjs')),
  BrandIconMaracuja: lazy(() => import('./BrandIconMaracuja.mjs')),
  BrandIconMarketplace: lazy(() => import('./BrandIconMarketplace.mjs')),
  BrandIconMeditationAndYoga: lazy(
    () => import('./BrandIconMeditationAndYoga.mjs'),
  ),
  BrandIconMetabolism: lazy(() => import('./BrandIconMetabolism.mjs')),
  BrandIconMilkThistle: lazy(() => import('./BrandIconMilkThistle.mjs')),
  BrandIconMint: lazy(() => import('./BrandIconMint.mjs')),
  BrandIconMouth: lazy(() => import('./BrandIconMouth.mjs')),
  BrandIconMultiplyRedPoints: lazy(
    () => import('./BrandIconMultiplyRedPoints.mjs'),
  ),
  BrandIconMuscle: lazy(() => import('./BrandIconMuscle.mjs')),
  BrandIconNail: lazy(() => import('./BrandIconNail.mjs')),
  BrandIconNetwork: lazy(() => import('./BrandIconNetwork.mjs')),
  BrandIconNewYear: lazy(() => import('./BrandIconNewYear.mjs')),
  BrandIconNfcPrimaryOption: lazy(
    () => import('./BrandIconNfcPrimaryOption.mjs'),
  ),
  BrandIconNfcSecondaryOption: lazy(
    () => import('./BrandIconNfcSecondaryOption.mjs'),
  ),
  BrandIconNight: lazy(() => import('./BrandIconNight.mjs')),
  BrandIconNoSmoking: lazy(() => import('./BrandIconNoSmoking.mjs')),
  BrandIconNose: lazy(() => import('./BrandIconNose.mjs')),
  BrandIconNoseSpray: lazy(() => import('./BrandIconNoseSpray.mjs')),
  BrandIconNowDelivery: lazy(() => import('./BrandIconNowDelivery.mjs')),
  BrandIconObjective: lazy(() => import('./BrandIconObjective.mjs')),
  BrandIconObjectiveWithRedcareSign: lazy(
    () => import('./BrandIconObjectiveWithRedcareSign.mjs'),
  ),
  BrandIconOnlinePharmacy: lazy(() => import('./BrandIconOnlinePharmacy.mjs')),
  BrandIconOrange: lazy(() => import('./BrandIconOrange.mjs')),
  BrandIconPackage: lazy(() => import('./BrandIconPackage.mjs')),
  BrandIconPatch: lazy(() => import('./BrandIconPatch.mjs')),
  BrandIconPercentages: lazy(() => import('./BrandIconPercentages.mjs')),
  BrandIconPharmacyInGermany: lazy(
    () => import('./BrandIconPharmacyInGermany.mjs'),
  ),
  BrandIconPickUp: lazy(() => import('./BrandIconPickUp.mjs')),
  BrandIconPiggyBank: lazy(() => import('./BrandIconPiggyBank.mjs')),
  BrandIconPill: lazy(() => import('./BrandIconPill.mjs')),
  BrandIconPillBlister: lazy(() => import('./BrandIconPillBlister.mjs')),
  BrandIconPlantbasedProduct: lazy(
    () => import('./BrandIconPlantbasedProduct.mjs'),
  ),
  BrandIconPost: lazy(() => import('./BrandIconPost.mjs')),
  BrandIconPowder: lazy(() => import('./BrandIconPowder.mjs')),
  BrandIconPower: lazy(() => import('./BrandIconPower.mjs')),
  BrandIconPregnancy: lazy(() => import('./BrandIconPregnancy.mjs')),
  BrandIconPrescriptionBonus: lazy(
    () => import('./BrandIconPrescriptionBonus.mjs'),
  ),
  BrandIconPresent: lazy(() => import('./BrandIconPresent.mjs')),
  BrandIconPrintAdvertisement: lazy(
    () => import('./BrandIconPrintAdvertisement.mjs'),
  ),
  BrandIconProcess: lazy(() => import('./BrandIconProcess.mjs')),
  BrandIconProtection: lazy(() => import('./BrandIconProtection.mjs')),
  BrandIconPumpkin: lazy(() => import('./BrandIconPumpkin.mjs')),
  BrandIconQuestion: lazy(() => import('./BrandIconQuestion.mjs')),
  BrandIconQuote: lazy(() => import('./BrandIconQuote.mjs')),
  BrandIconRating: lazy(() => import('./BrandIconRating.mjs')),
  BrandIconRealisticHeart: lazy(() => import('./BrandIconRealisticHeart.mjs')),
  BrandIconRedcareWebShop: lazy(() => import('./BrandIconRedcareWebShop.mjs')),
  BrandIconRegularPrescription: lazy(
    () => import('./BrandIconRegularPrescription.mjs'),
  ),
  BrandIconSachet: lazy(() => import('./BrandIconSachet.mjs')),
  BrandIconSale: lazy(() => import('./BrandIconSale.mjs')),
  BrandIconSaveChf: lazy(() => import('./BrandIconSaveChf.mjs')),
  BrandIconSaveEuro: lazy(() => import('./BrandIconSaveEuro.mjs')),
  BrandIconSavings: lazy(() => import('./BrandIconSavings.mjs')),
  BrandIconScanBarcode: lazy(() => import('./BrandIconScanBarcode.mjs')),
  BrandIconScanQrCode: lazy(() => import('./BrandIconScanQrCode.mjs')),
  BrandIconScanWithApp: lazy(() => import('./BrandIconScanWithApp.mjs')),
  BrandIconSelectionInApp: lazy(() => import('./BrandIconSelectionInApp.mjs')),
  BrandIconShield: lazy(() => import('./BrandIconShield.mjs')),
  BrandIconShippingTracking: lazy(
    () => import('./BrandIconShippingTracking.mjs'),
  ),
  BrandIconShopping: lazy(() => import('./BrandIconShopping.mjs')),
  BrandIconShoppingBag: lazy(() => import('./BrandIconShoppingBag.mjs')),
  BrandIconSicknessNausea: lazy(() => import('./BrandIconSicknessNausea.mjs')),
  BrandIconSkinProblems: lazy(() => import('./BrandIconSkinProblems.mjs')),
  BrandIconSkincare: lazy(() => import('./BrandIconSkincare.mjs')),
  BrandIconSkincareIngredient: lazy(
    () => import('./BrandIconSkincareIngredient.mjs'),
  ),
  BrandIconSnacks: lazy(() => import('./BrandIconSnacks.mjs')),
  BrandIconSnowflake: lazy(() => import('./BrandIconSnowflake.mjs')),
  BrandIconSportsBottle: lazy(() => import('./BrandIconSportsBottle.mjs')),
  BrandIconSpray: lazy(() => import('./BrandIconSpray.mjs')),
  BrandIconStomach: lazy(() => import('./BrandIconStomach.mjs')),
  BrandIconStrategy: lazy(() => import('./BrandIconStrategy.mjs')),
  BrandIconSun: lazy(() => import('./BrandIconSun.mjs')),
  BrandIconSupport: lazy(() => import('./BrandIconSupport.mjs')),
  BrandIconSuppositories: lazy(() => import('./BrandIconSuppositories.mjs')),
  BrandIconSustainability: lazy(() => import('./BrandIconSustainability.mjs')),
  BrandIconSwissFranc: lazy(() => import('./BrandIconSwissFranc.mjs')),
  BrandIconSyringe: lazy(() => import('./BrandIconSyringe.mjs')),
  BrandIconSyrup: lazy(() => import('./BrandIconSyrup.mjs')),
  BrandIconTonometer: lazy(() => import('./BrandIconTonometer.mjs')),
  BrandIconTooth: lazy(() => import('./BrandIconTooth.mjs')),
  BrandIconTransport: lazy(() => import('./BrandIconTransport.mjs')),
  BrandIconTv: lazy(() => import('./BrandIconTv.mjs')),
  BrandIconValerian: lazy(() => import('./BrandIconValerian.mjs')),
  BrandIconVegan: lazy(() => import('./BrandIconVegan.mjs')),
  BrandIconVideo: lazy(() => import('./BrandIconVideo.mjs')),
  BrandIconVoucher: lazy(() => import('./BrandIconVoucher.mjs')),
  BrandIconWarehouse: lazy(() => import('./BrandIconWarehouse.mjs')),
  BrandIconWebShop: lazy(() => import('./BrandIconWebShop.mjs')),
}
